module.exports = __webpack_public_path__ + "static/img/1087.6b7d421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1087.jpg
// module id = 269
// module chunks = 0